/**
 * Provides a reactive page title and subtitle for admin pages.
 * Set the title in each admin page's setup; the layout's navbar reads it.
 */
export function useAdminPageTitle() {
  const title = useState<string>('adminPageTitle', () => '')
  const subtitle = useState<string>('adminPageSubtitle', () => '')

  function setTitle(newTitle: string, newSubtitle = '') {
    title.value = newTitle
    subtitle.value = newSubtitle
  }

  return { title, subtitle, setTitle }
}
